import React, { useContext, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { CustomTheme } from "../AppCustom"
import { FabricDialog } from "../components/CopyrightDialog"
import { ACTIONS_SET_IMAGES_COPYRIGHT_COMPLIANT } from "../redux/reducers/images"

const COPYRIGHT_WARNING = {

    title: "i18n.intelWarn.copyrightTitle",

    text: ["i18n.intelWarn.p1",

        "i18n.intelWarn.p2",

        "i18n.intelWarn.p3"],

    checkbox: "i18n.intelWarn.check"
}

export const useCopyrightWarning = (compliant: boolean, onRejection: () => void, onAcceptance: (selectedFiles?: File[]) => void, selectedFiles?: File[]) => {

    const dispatch = useDispatch();

    let [copyrightWarning, showCopyrightWarning] = useState(false)
    let [copyrightCompliance, setCopyrightCompliance] = useState(false)

    const { t } = useTranslation();

    useEffect(() => {
        setCopyrightCompliance(compliant);
    }, [compliant])

    const theme = useContext(CustomTheme);

    return selectedFiles && !copyrightCompliance ? <FabricDialog
        theme={theme}
        text={COPYRIGHT_WARNING.text.map(p => t(p))}
        title={t(COPYRIGHT_WARNING.title)}
        checkbox={t(COPYRIGHT_WARNING.checkbox)}
        visible
        onNegative={() => {
            showCopyrightWarning(false)
            onRejection()
        }}
        onPositive={() => {
            dispatch({ type: ACTIONS_SET_IMAGES_COPYRIGHT_COMPLIANT })
            setCopyrightCompliance(true)
            onAcceptance(selectedFiles);
        }} /> : null

}